
import { useState } from "react";
import { Mail } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { requestPasswordReset } from "@/services/authService";
import { IconInput } from "./IconInput";
import { SubmitButton } from "./SubmitButton";
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";
import { Link } from "react-router-dom";

export function ResetPasswordForm() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      await requestPasswordReset(email);
      setIsSuccess(true);
      toast({
        title: "Email enviado",
        description: "Verifique sua caixa de entrada para redefinir sua senha.",
        variant: "default",
      });
    } catch (error: any) {
      console.error("Password reset error:", error);
      toast({
        title: "Erro",
        description: "Não foi possível enviar o email de redefinição de senha. Verifique se o email está correto.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="text-center space-y-6">
        <div className="bg-green-50 text-green-800 p-4 rounded-lg">
          <h3 className="text-lg font-medium">Email enviado!</h3>
          <p className="mt-2">
            Enviamos um link de redefinição de senha para {email}. 
            Por favor, verifique sua caixa de entrada e spam.
          </p>
        </div>
        
        <Button 
          variant="outline" 
          className="mt-4"
          onClick={() => setIsSuccess(false)}
        >
          Usar outro email
        </Button>
      </div>
    );
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="space-y-6 mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold">Esqueceu sua senha?</h2>
          <p className="text-gray-600 mt-1">
            Digite seu email e enviaremos um link para redefinir sua senha.
          </p>
        </div>

        <IconInput
          id="email"
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="seu@email.com"
          required
          disabled={isLoading}
          Icon={Mail}
        />

        <SubmitButton
          isLoading={isLoading}
          text="Enviar link de redefinição"
          loadingText="Enviando..."
        />
      </form>
      
      <CardFooter className="text-center text-sm text-gray-600 justify-center pt-6 pb-0 px-0 mt-4">
        <p className="w-full text-center">
          Lembrou sua senha?{" "}
          <Link to="/login" className="text-brand-teal hover:underline font-medium transition">
            Voltar ao login
          </Link>
        </p>
      </CardFooter>
    </>
  );
}
